import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";

import {
    Divider,
    Drawer,
    List,
    ListItem,
    ListItemText,
    Typography,
} from '@material-ui/core';

import {
    Translate,
    currentLanguage,
} from "src/shared_modules/i18n";

import {
    showStaticContent
} from "src/shared_modules/veu-visitors-core/actions/content";

import VisitorButton from "./visitor-button"
import AccountMenu from "./account-menu";
import HelpButton from "./help-button";
import LoginButton from "./login-button";
import LanguageSwitch from './language-switch';

import { NAME, MODULE, VERSION, COPYRIGHT } from "src/constants";

import {
    VEU_CORE_VERSION,
    VEU_NAME
} from "src/shared_modules/veu-visitors-core/constants";


import './mainnav.css';

class MobileMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
        this.handleClose = this.handleClose.bind(this);
        this.onClickLegals = this.onClickLegals.bind(this);
    }

    componentDidMount() {
    }

    handleClose(event) {
        if( this.props.onClose )
            this.props.onClose();
    }

    renderSubHeadline( label ) {
        return(<React.Fragment>
                    <Divider component="li" />
                    <li>
                        <Typography
                                className="mobile-menu-subheader"
                                display="block"
                                variant="caption"
                            >
                            <Translate>{label}</Translate>
                        </Typography>
                    </li>
            </React.Fragment>);
    }

    renderLocation() {
        return (<React.Fragment>
                    {this.renderSubHeadline("main-nav.location")}
                    <div>TODO standorte near future</div>
            </React.Fragment>);
    }


    onClickLegals( url ) {
        this.props.showStaticContent( url );
        if( this.props.onClose )
            this.props.onClose();
    }


    renderFooter() {

        return (<React.Fragment>
                    {this.renderSubHeadline("main-nav.legal")}

                    <ListItemLink onClick={()=>{ this.onClickLegals("legal-notice.html") }} >
                        <ListItemText primary={<Translate>footer.legal-notice</Translate>} />
                    </ListItemLink>
                    <ListItemLink onClick={()=>{ this.onClickLegals("privacy-policy.html") }} >
                        <ListItemText primary={<Translate>footer.privacy-policy</Translate>} />
                    </ListItemLink>
                    <ListItemLink onClick={()=>{ this.onClickLegals("therms-of-use.html") }} >
                        <ListItemText primary={<Translate>footer.condition-of-use</Translate>} />
                    </ListItemLink>
                    <ListItemLink onClick={()=>{ this.onClickLegals("cookies.html") }} >
                        <ListItemText primary={<Translate>footer.cookie-policy</Translate>} />
                    </ListItemLink>


                    <footer className="app-footer">
                        <div>
                            {COPYRIGHT} <a target="_blank" rel="noopener noreferrer" href="http:\\seven-m.de">SEVEN M GmbH</a>
                        </div>
                        <div>
                            {NAME} {MODULE} v{VERSION} - {VEU_NAME} v{VEU_CORE_VERSION}
                        </div>
                    </footer>
            </React.Fragment>);

    }

    renderEventName() {
        let lang = currentLanguage().code2;
        let eventname = this.props.event.name[lang];

        if( !this.props.event.logoPath ) {
            return(<Typography
                    className="mobile-menu-eventname"
                    display="block"
                    variant="h6"
                    color="primary"
                >
                {eventname}
            </Typography>);
        }

        let langpath = this.props.event.logoPath[lang];
        let fallbackpath = this.props.event.logoPath["en"];
        let logoUrl = "";

        if (langpath) {
            logoUrl = this.props.cdn.content.url + "/medialib/image/" + langpath;
        } else if (fallbackpath) {
            logoUrl = this.props.cdn.content.url + "/medialib/image/" + fallbackpath;
        }

        return(<div className="app-name">
                <img className="mobile-event-logo" src={logoUrl} alt={eventname} />
            </div>);
    }

    render() {

        let cssClass = this.props.className + " mobile-menu";

        // subheader visitors
        let { pathname } = this.props.location;
        let showVisitors = false;
        // if user is on home he has no access to event for any reason so there is no visitor indicator!!!!
        if( !pathname.endsWith("home") ) {
            let isPublic = (this.props.event.accesslevel === "public");
            showVisitors = this.props.event.onAir && ( this.props.user.loggedIn || isPublic );
        }

        // sub header languages
        let isSingleLang = (this.props.event.languages.length === 1 );
        let langsubhead = "main-nav.language";
        if( isSingleLang ) {
            langsubhead = "main-nav.one-language";
        }

        return (<Drawer anchor="left"
                        PaperProps={{ className: cssClass }}
                        open={this.props.isOpen}
                        onClose={this.handleClose}
                    >
                        {this.renderEventName()}
                        <Divider />
                <List>
                    <LoginButton mobile onClick={this.handleClose}/>
                    <AccountMenu mobile onLeave={this.handleClose}/>
                    {this.renderSubHeadline(langsubhead)}
                    <LanguageSwitch mobile />

                    {showVisitors && this.renderSubHeadline("main-nav.visitors")}
                    <VisitorButton mobile onClick={this.handleClose} />
                    <Divider />
                    <HelpButton mobile onClick={this.handleClose} />
                    {this.renderFooter()}
                </List>

            </Drawer>);
    }
}

function ListItemLink(props) {
    return <ListItem button dense component="a" {...props} />;
  }

/*
 * ---------------------------------------------------------------------
 * MobileMenu prop Types
 * ---------------------------------------------------------------------
 */
MobileMenu.propTypes = {
    lang: PropTypes.string,
    user: PropTypes.object,
    event: PropTypes.object
};
/*
 * ---------------------------------------------------------------------
 * MobileMenu Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = ( state, ownProps ) => {
    return {
        lang: state.system.currentLang,
        user : state.user,
        event : state.event,
        cdn: state.system.cdn,
    };
};

const mapDispatchToProps = {
    showStaticContent,
    currentLanguage
};

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */

export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(withRouter(MobileMenu));
